import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalCloseBtnFn = /* @__PURE__ */ createRecipe('modalCloseBtn', {}, [])

const modalCloseBtnVariantMap = {}

const modalCloseBtnVariantKeys = Object.keys(modalCloseBtnVariantMap)

export const modalCloseBtn = /* @__PURE__ */ Object.assign(memo(modalCloseBtnFn), {
  __recipe__: true,
  __name__: 'modalCloseBtn',
  raw: (props) => props,
  variantKeys: modalCloseBtnVariantKeys,
  variantMap: modalCloseBtnVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalCloseBtnVariantKeys)
  },
})